class QuizCart {
    constructor() {
        this.items = [],
            this.totalPrice = 0,
            this.noDiscountTotalPrice = 0
        this.scoops = [];
    }

    async setScoops(results) {
        let scoops = []
        const productPropertiesShopify = ['oneTimeBuyMainProducts', 'oneTimeBuySecondaryProducts', 'subscriptionMainProducts',
            'subscriptionSecondaryProducts', 'singleUpsellProducts', 'singleUpsellOfferProducts'];
        productPropertiesShopify.map(productProperty => {
            results[productProperty].forEach(product => {
                if (product.scoopId) {
                    scoops[product.variants[0].id] = this.createScoopProductFromVariantId(product.scoopId);
                }
            })
        })
        if (results.subscribeBodyFuelPro.scoopId) {
            scoops[results.subscribeBodyFuelPro.variants[0].id]
                = this.createScoopProductFromVariantId(results.subscribeBodyFuelPro.scoopId);
        }
        if (results.subscribeBodyFuelPro.scoopId) {
            scoops[results.subscribeBodyFuelPro.variants[0].id]
                = this.createScoopProductFromVariantId(results.subscribeBodyFuelPro.scoopId);
        }
        this.scoops = scoops
    }

    createScoopProductFromVariantId(id) {
        return {
            price: 0,
            compare_at_price: 0,
            variants: [{id: id}]
        }
    }

    addItem(product) {
        let id = product.variants[0].id;
        let itemKey = this.items.findIndex(item => item.id === id);
        let price = Math.round(parseFloat(product.price)) / 100
        let discountPrice = Math.round(parseFloat(product.compare_at_price ?? 0)) / 100
        this.totalPrice += parseFloat(price);
        this.noDiscountTotalPrice += parseFloat(discountPrice);
        if (itemKey === -1) {
            return this.items.push({
                id,
                quantity: 1,
            })
        }
        console.log(product.title,'product.maxQty', product.maxQty, 'this.items[itemKey].quantity', this.items[itemKey].quantity)
        return this.items[itemKey].quantity < product.maxQty ? this.items[itemKey].quantity++ : this.items[itemKey].quantity;
    }

    removeItem(product) {
        let id = product.variants[0].id;
        let itemKey = this.items.findIndex(item => item.id === id);
        let price = Math.round(parseFloat(product.price)) / 100
        let discountPrice = Math.round(parseFloat(product.compare_at_price ?? 0)) / 100
        if (itemKey === -1 || this.items[itemKey].quantity < 1
            || this.items[itemKey].quantity <= product.minQty) {
            return null;
        }
        this.totalPrice -= parseFloat(price);
        this.noDiscountTotalPrice -= parseFloat(discountPrice);
        return this.items[itemKey].quantity--
    }

    getItemQuantity(id) {
        console.log('getItemQuantity', id, this.items)
        let item = this.items.find(item => item.id === id);
        return item ? item.quantity : 0;
    }

    routeToCheckout() {
        if (localStorage.getItem('cart-subscription') !== 'true') {
            window.location.replace('/checkout')
            return;
        }
        function get_cookie(name) {
            return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
        }
        const token = get_cookie('cart');
        const myshopify_domain = 'nutri-genetix-ngx.myshopify.com';
        const checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&currency=GBP";
        window.location.replace(checkout_url)
    }

    async updateScoops(){
        let scoopCart = new QuizCart();
        this.items.forEach(item => {
            if (this.scoops[item.id] && item.quantity) {
                scoopCart.addItem(this.scoops[item.id])
            }
        });
        scoopCart.items.map(item => {
            item.properties = {
                "_channel": "Quiz",
            }
            return item;
        });
        return await fetch(window.Shopify.routes.root + 'cart/add.js',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    items: scoopCart.items
            })
        })
    }

    async updateShopifyCart(subscription = false, clearCart = true) {
        if (subscription) {
            this.items.map(item => {
                item.properties = {
                    "shipping_interval_frequency": 1,
                    "shipping_interval_unit_type": "Month",
                    "_channel": "Quiz"
                }
                return item;
            });
        } else{
            this.items.map(item => {
                item.properties = {
                    "_channel": "Quiz",
                }
                return item;
            });
        }
        if (!clearCart) {
            await this.updateScoops();
            return fetch(window.Shopify.routes.root + 'cart/add.js',
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    body: JSON.stringify({
                        items: this.items
                    })
                })
        }

        fetch(window.Shopify.routes.root + 'cart/clear.js', {}).then(async () => {
            await this.updateScoops();
            fetch(window.Shopify.routes.root + 'cart/add.js',
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    body: JSON.stringify({
                        items: this.items
                    })
                })
        })
    }

    async lastStepUpdateCart(subscription = false) {
        if (subscription) {
            this.items[0]['properties'] = {
                "shipping_interval_frequency": 1,
                "shipping_interval_unit_type": "Month",
                 "_channel": "Quiz",
            };
        }
        this.items.forEach(item => {
            if (this.scoops[item.id]) {
                this.addItem(this.scoops[item.id])
            }
        });

      
        return fetch(window.Shopify.routes.root + 'cart/add.js',
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    items: this.items
                })
            })
    }

    getProductBySlug(productSlug, products) {
        return products.find(product => product.singlePurchaseSlug === productSlug)
    }

    getTotalPrice(){
        let totalToFloat = this.parseToFloatWithDecimal(this.totalPrice)
        return this.getLocalisedPrice(totalToFloat);
    }

    getNoDiscountTotalPricePrice(){
        let totalToFloat = this.parseToFloatWithDecimal(this.noDiscountTotalPrice)
        return this.getLocalisedPrice(totalToFloat);
    }

    // helpers

    isCurrencyWithComma() {
        function getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }

        const selectedCurrency = getCookie('cart_currency');
        if(!['USD', 'EUR', 'GBP'].includes(selectedCurrency)) {
            return true
        }
        return false;
    }
    getLocalisedPrice(price) {
        if (this.isCurrencyWithComma()) {
            return price.toLocaleString("en-AT", { minimumFractionDigits: 2 });
        }
        return price.toLocaleString("en-GB", { minimumFractionDigits: 2 });
    }
    parseToFloatWithDecimal(price){
        return parseFloat((Math.round(price * 100) / 100).toFixed(2))
    }
}

